import { CloseCircleFilled } from '@ant-design/icons';
import { DatePicker, Form, Typography } from 'antd';
import { useMemo } from 'react';

import { MultipleSelect, SearchButtons } from '@app/components';
import { DATE_PICKER_FORMAT, OFF, rangePickerLocale } from '@app/constants';

import {
  getDocumentStatusLabel,
  type MedicalCardRegistryFiltersProps,
} from '../types';

const { Text } = Typography;
const { RangePicker } = DatePicker;

export const MedicalCardRegistryFilters = ({
  filtersData,
  isFiltersLoading,
  selectedStatuses,
  setSelectedStatuses,
  selectedDoctors,
  setSelectedDoctors,
  submitFormHandler,
  handleReset,
}: MedicalCardRegistryFiltersProps) => {
  const [form] = Form.useForm();

  const statusesOptions = useMemo(() => {
    return (
      filtersData?.Statuses?.map((status: string) => ({
        label: getDocumentStatusLabel(status),
        value: status,
      })) || []
    );
  }, [filtersData]);

  const doctorsOptions = useMemo(() => {
    return (
      filtersData?.Doctors?.map(({ DoctorId, DoctorName }) => ({
        label: DoctorName ?? '',
        value: DoctorId,
        DoctorName: DoctorName ?? '',
      })) || []
    );
  }, [filtersData]);

  return (
    <div className="filters-container">
      <Form
        form={form}
        layout="vertical"
        autoComplete={OFF}
        onFinish={submitFormHandler}
      >
        <div className="dates-container">
          <div className="date-item">
            <Text strong className="label">
              Период создания
            </Text>

            <Form.Item name="CreationDateRange">
              <RangePicker
                format={DATE_PICKER_FORMAT}
                disabled={isFiltersLoading}
                allowEmpty={[true, true]}
                locale={rangePickerLocale}
                size="middle"
                allowClear={{
                  clearIcon: <CloseCircleFilled />,
                }}
              />
            </Form.Item>
          </div>

          <div className="date-item">
            <Text strong className="label">
              Подписание врачом
            </Text>

            <Form.Item name="DoctorSignedDateRange">
              <RangePicker
                format={DATE_PICKER_FORMAT}
                allowEmpty={[true, true]}
                disabled={isFiltersLoading}
                locale={rangePickerLocale}
                size="middle"
                allowClear={{
                  clearIcon: <CloseCircleFilled />,
                }}
              />
            </Form.Item>
          </div>

          <div className="date-item">
            <Text strong className="label">
              Подписание заведующим
            </Text>

            <Form.Item name="ChiefSignedDateRange">
              <RangePicker
                format={DATE_PICKER_FORMAT}
                allowEmpty={[true, true]}
                disabled={isFiltersLoading}
                locale={rangePickerLocale}
                size="middle"
                allowClear={{
                  clearIcon: <CloseCircleFilled />,
                }}
              />
            </Form.Item>
          </div>
        </div>

        <div className="selectors-container">
          <div className="selectors">
            <MultipleSelect
              className="user-selector"
              placeholder="Все статусы"
              allOptions={statusesOptions}
              width={250}
              minWidth={250}
              selectedOption={selectedStatuses}
              loader={isFiltersLoading}
              setSelectedOptions={setSelectedStatuses}
              dataTestId="statuses-filter"
              dropdownDataTestId="statuses-dropdown"
              optionDataTestId="status-option"
            />

            <MultipleSelect
              className="user-selector"
              placeholder="Все врачи"
              allOptions={doctorsOptions}
              width={250}
              minWidth={250}
              selectedOption={selectedDoctors}
              loader={isFiltersLoading}
              setSelectedOptions={setSelectedDoctors}
              filterName="DoctorName"
              dataTestId="doctors-filter"
              dropdownDataTestId="doctors-dropdown"
              optionDataTestId="doctor-option"
            />
          </div>

          <SearchButtons
            className="desktop-buttons"
            resetAll={handleReset}
            showData={form.submit}
          />
        </div>
      </Form>
    </div>
  );
};
